module.exports = __webpack_public_path__ + "img/resultIcon.90f68ce2.svg";